var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromoMaterialsDownloadButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33268 1.66667C1.33268 1.11438 1.7804 0.666667 2.33268 0.666667H3.66602V0H2.33268C1.41221 0 0.666016 0.746192 0.666016 1.66667V8.33333C0.666016 9.25381 1.41221 10 2.33268 10H11.666C12.5865 10 13.3327 9.25381 13.3327 8.33333V1.66667C13.3327 0.746192 12.5865 0 11.666 0H10.3327V0.666667H11.666C12.2183 0.666667 12.666 1.11438 12.666 1.66667V8.33333C12.666 8.88562 12.2183 9.33333 11.666 9.33333H2.33268C1.7804 9.33333 1.33268 8.88562 1.33268 8.33333V1.66667Z",
    fill: "#007AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76365 4.7643L7.33268 6.19527V0.333333H6.66602V6.19527L5.23505 4.7643L4.76365 5.23571L6.99935 7.47141L9.23505 5.23571L8.76365 4.7643Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoMaterialsDownloadButton);
export default __webpack_public_path__ + "static/media/promoMaterialsDownloadButton.699fba5f660c5ef19c40097f103cf75a.svg";
export { ForwardRef as ReactComponent };